
namespace TabAurous.Stock {

    import fld = StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StockItemGroupGrid extends Serenity.EntityGrid<StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return StockItemRow.idProperty; }
        protected getInsertPermission() { return StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return StockItemRow.localTextPrefix; }
        //protected getService() { return StockItemService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};
        withBom: boolean;
        constructor(container: JQuery) {
            super(container);
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            let x;
            StockItemService.StockGroupList({},
                response =>
                    x = response,
                { async: false });

            let check = false;
            for (let rateitem of x.Entities) {
                rateitem[this.getIdProperty()] = rateitem.StockId;
                //   alert('ID ' + rateitem.CostId);
                check = true;
                this.view.addItem(rateitem);
            }
            //grid.setData(x1, true);
            //var c = grid.getData();
            if (!check) {
                this.view.setItems([], true);
            }
            this.view.setGrouping([{ getter: 'ProductCode' }])
            return grid;
        }
        private setSaveButtonState() {
            this.toolbar.findButton('apply-changes-button').toggleClass('disabled',
                Object.keys(this.pendingChanges).length === 0);
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            this.setSaveButtonState();
            this.view.setGrouping([{ getter: 'ProductCode' }])
            return super.onViewProcessData(response);
        }



        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        private getEffectiveValue(item, field): any {
            var pending = this.pendingChanges[item.ProductID];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }

        protected getButtons(): Serenity.ToolButton[] {
            this.withBom = true;
            return [{
                title: 'With BOM',
                cssClass: 'bombtn',
                icon: '',
                onClick: () => {
                    var x = this.toolbar.findButton('bombtn');
                    if (this.withBom) {
                        x.text('Without BOM');
                        this.withBom = false;
                    } else {
                        x.text('With BOM');
                        this.withBom = true;
                    }
                }
            }, {
                title: 'Export',
                cssClass: 'import-xlsx-button',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    let _stockItemRows: StockItemRow[] = [];
                    this.view.getItems().forEach((v, i) => {
                        _stockItemRows.push({});
                    });

                    Q.postToService({
                        service: StockItemService.baseUrl + '/StockExportExcel',
                        request: {
                            stockRows: _stockItemRows,
                            withBOM: this.withBom
                        },

                        target: '_blank'
                    });
                }
            }, TabAurous.Common.ReportHelper.createToolButton({
                title: 'Report(PDF)',
                cssClass: 'export-pdf-button',
                reportKey: 'Stock.StockItemGroup'
            })];
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 2500;
            return opt;
        }

        protected updateInterface() {
            super.updateInterface();
            this.setTitle("Stock Report")
        }

    }
}